import React from "react";
import { GlassCard } from "../components/GlassCard";
import { NumberInput } from "../components/NumberInput";
import { useBudget } from "../context/BudgetContext";
import { useI18n } from "../context/I18nContext";
import { REVENU_FIELDS } from "../lib/constants";
import { formatCurrency } from "../lib/i18n";
import { Wallet } from "lucide-react";

export const RevenusModule = () => {
  const { t, lang } = useI18n();
  const { state, setRevenuField, indicators } = useBudget();

  return (
    <div className="flex flex-col gap-8" data-testid="module-revenus">
      <header className="flex flex-col gap-2">
        <span className="text-xs font-bold uppercase tracking-[0.2em] text-slate-400">
          {t.modules.revenus}
        </span>
        <h1 className="text-3xl sm:text-4xl tracking-tighter text-indigo-950" style={{ fontFamily: "Outfit, sans-serif" }}>
          {t.revenus.title}
        </h1>
        <p className="text-slate-500 text-base max-w-2xl">{t.revenus.subtitle}</p>
      </header>

      <GlassCard>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {REVENU_FIELDS.map((f) => (
            <NumberInput
              key={f}
              testId={`input-revenu-${f}`}
              label={t.revenus[f]}
              value={state.revenus[f]}
              onChange={(v) => setRevenuField(f, v)}
            />
          ))}
        </div>
      </GlassCard>

      <div
        data-testid="total-revenus"
        className="rounded-2xl bg-indigo-950 text-white p-6 md:p-8 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 shadow-lg"
      >
        <div className="flex items-center gap-4">
          <div className="w-12 h-12 rounded-xl bg-white/10 flex items-center justify-center">
            <Wallet className="w-5 h-5 text-emerald-300" />
          </div>
          <div className="flex flex-col">
            <span className="text-xs uppercase tracking-[0.2em] text-white/60">{t.revenus.total}</span>
            <span className="text-sm text-white/70">{t.revenus.perMonth}</span>
          </div>
        </div>
        <span
          className="text-4xl sm:text-5xl font-medium tracking-tighter text-emerald-300"
          style={{ fontFamily: "Outfit, sans-serif" }}
          data-testid="total-revenus-value"
        >
          {formatCurrency(indicators.revenus, lang)}
        </span>
      </div>
    </div>
  );
};
